// Auto-generated from translation.csv; do not edit manually
export const jaJP = {
  "accountGuide": {
    "content": "Toukaのいずれかのゲームを開き、ゲーム内の設定画面に進んでメールアドレスを連携すると、特価商品の割引を受けることができます！",
    "title": "アカウントの作成方法は？"
  },
  "bottomNav": {
    "home": "ホーム",
    "myOrders": "マイ注文"
  },
  "common": {
    "loading": "読み込み中...",
    "noData": "データなし",
    "server": "サーバー"
  },
  "auth": {
    "tokenExpired": "ログインの有効期限が切れました"
  },
  "errors": {
    "900400": "内部パラメータエラー",
    "900401": "ログイン認証に失敗しました",
    "900402": "ログインの有効期限が切れました",
    "1000000": "システムエラーです。後でもう一度お試しください",
    "1000001": "システムパラメータエラーです。後でもう一度お試しください",
    "1000002": "画像認証IDまたはコードを入力してください",
    "1000003": "メールアドレスが無効です",
    "1000004": "画像認証コードが無効です",
    "1000005": "認証コードは送信済みです。1分後にもう一度お試しください",
    "1000006": "認証コードの送信上限に達しました。明日もう一度お試しください",
    "1000007": "メールアドレスを入力してください",
    "1000008": "認証コードを入力してください",
    "1000009": "認証コードが無効です",
    "1000010": "ログイントークンの取得に失敗しました",
    "1000011": "商品は無効です。他の商品を選択してください",
    "1000012": "商品の購入上限を超えています。他の商品を選択してください",
    "1000013": "商品は販売終了しました",
    "1000014": "支払い方法が有効ではありません",
    "1000015": "このアカウントでは商品を購入できません。カスタマーサポートにお問い合わせください",
    "1000016": "注文の作成に失敗しました。もう一度お試しください",
    "1000017": "この注文はキャンセルできません",
    "1000018": "1回の購入数量上限に達しました",
    "1000019": "認証コードの有効期限が切れました。再取得してください"
  },
  "footer": {
    "language": "中国語（簡体字）",
    "privacyPolicy": "プライバシーポリシー",
    "refundPolicy": "返金ポリシー",
    "termsOfService": "利用規約",
    "userSupport": "ユーザーサポート",
    "downloadNow": "今すぐダウンロード！"
  },
  "header": {
    "characterName": "キャラクター名",
    "gameServer": "ゲームサーバー",
    "selectGameServer": "ゲーム地域を選択",
    "greeting": "こんにちは",
    "loginPrompt": "ログインしてください",
    "switchServer": "切り替え",
    "title": "ゲームチャージセンター",
    "logout": "ログアウト"
  },
  "games": {
    "bamBamSquad": "BamBamSquad",
    "oopsieCroco": "おっと！クロコ"
  },
  "history": {
    "backToGameZone": "ゲームストアに戻る",
    "allGames": "すべてのゲーム",
    "empty": "注文なし",
    "filter": {
      "all": "すべて",
      "closed": "クローズ済み",
      "completed": "完了済み",
      "inProgress": "進行中",
      "pendingDelivery": "発送待ち"
    },
    "orderTime": "注文時間:",
    "pendingAutoCancelPrefix": "注文は",
    "pendingAutoCancelSuffix": "後に自動キャンセルされます",
    "cancelOrder": "注文をキャンセル",
    "payOrder": "支払う",
    "cancelOrderConfirmTitle": "注文をキャンセルしますか？",
    "cancelOrderConfirmPrimary": "キャンセルを確定",
    "cancelOrderDismiss": "今はしない",
    "previousPage": "前のページ",
    "nextPage": "次のページ",
    "status": {
      "cancelled": "キャンセル済み",
      "completed": "取引完了",
      "paid": "支払い済み",
      "pending": "未払い",
      "shipped": "発送済み"
    }
  },
  "home": {
    "selectGame": "チャージするゲームを選択してください",
    "selectGameMobileTitle": "チャージゲームを選択",
    "selectGameParts": {
      "prefix": "",
      "keyword": "チャージ",
      "suffix": "するゲームを選択してください"
    },
    "noRoleAccount": "このゲームにはまだキャラクターがありません。購入前にゲーム内でキャラクターを作成してください。",
    "noRoleRefreshPrefix": "アカウントは作成済みですか？タップして",
    "noRoleRefreshAction": "更新",
    "noRoleRefreshing": "更新中…",
    "noRoleRefreshNotFound": "キャラクター情報が見つかりません",
    "noRoleRefreshFailed": "更新に失敗しました。しばらくしてからお試しください。"
  },
  "login": {
    "agreeTerms": {
      "and": "と",
      "prefix": "私はプライバシーポリシーおよび利用規約を読み、同意します",
      "privacy": "プライバシーポリシー",
      "terms": "利用規約"
    },
    "cancel": "キャンセル",
    "bindGameGuide": "ゲーム連携について",
    "bindGameGuideContent": "任意のToukaゲームを開き、\nゲーム内の設定画面で\nメールアドレスを連携すると、\n特価商品をお楽しみいただけます！",
    "captchaPlaceholder": "認証コード",
    "invalidCaptcha": "4桁の認証コードを入力してください",
    "email": "メールアドレス",
    "emailNotBound": "取得に失敗しました。ゲーム内で連携したメールアドレスを入力してください〜",
    "emailPlaceholder": "メールアドレスを入力してください",
    "keepLogin": "15日間ログイン状態を保持する",
    "loading": "ログイン中...",
    "loginToStore": "Toukaストアにログイン",
    "noAccount": "まだアカウントをお持ちでないですか？",
    "password": "パスワード",
    "passwordPlaceholder": "パスワードを入力してください",
    "submit": "ログイン",
    "title": "ログイン",
    "invalidEmail": "有効なメールアドレスを入力してください"
  },
  "logout": {
    "cancel": "取消",
    "confirm": "確認",
    "dontRemind": "次回から表示しない",
    "messageLine1": "ログアウト後、過去30日以内にログインしたすべてのデバイスの",
    "messageLine2": "ログイン状態が無効になります。",
    "title": "ご案内"
  },
  "menu": {
    "contactSupport": "カスタマーサービス",
    "gameList": "ゲームリスト",
    "myOrders": "マイオーダー"
  },
  "paymentSuccess": {
    "account": "アカウント：",
    "celebrationTitle": "購入成功",
    "confirm": "確定",
    "getPaymentInfoFailed": "支払い情報の取得に失敗しました",
    "loading": "読み込み中...",
    "orderDate": "注文日：",
    "orderId": "注文番号：",
    "paymentMethod": "支払い方法：",
    "paypal": "PayPal",
    "price": "価格：",
    "purchaseContent": "購入内容：",
    "quantity": "購入数量：",
    "serverAndCharacter": "サーバー/キャラ：",
    "title": "ご購入ありがとう",
    "total": "合計：",
    "unionPay": "UnionPay",
    "amountPaid": "お支払い金額：",
    "closeModal": "閉じる"
  },
  "productModal": {
    "confirm": "確定",
    "purchaseDetails": "購入詳細",
    "quantity": "数量：",
    "total": "合計：",
    "unitPrice": "単価："
  },
  "products": {
    "giftPacks": "パッケージ",
    "diamond": "ダイヤ",
    "products": "商品",
    "vouchers": "バウチャー",
    "toukaCoin": "Toukaコイン",
    "toukaCoinBonusTip": "TOUKA Storeで購入すると、追加10%のボーナスがもらえます！",
    "superValue": "お得",
    "limitShort": "制限",
    "remainingShort": "残り時間",
    "giftPackLimitType": {
      "lifetime": "永久特価",
      "weekly": "週間特価",
      "monthly": "月間特価"
    },
    "howToUseVouchers": "代金券の使い方",
    "voucherGuide": {
      "title": "代金券の使い方",
      "step1": "1. ゲーム内メールで購入したバウチャーをお受け取りください。",
      "step2": "2. ゲーム内ショップタブの上部で、所持しているバウチャー枚数を確認できます。ギフトパックの購入に必要な枚数に達すると、バウチャーが優先的に使用されます。",
      "backToProducts": "商品リストに戻る"
    },
    "luxuryVouchers": "高級バウチャー"
  },
  "purchaseConfirm": {
    "card": "クレジットカード／デビットカード",
    "confirm": "確認",
    "dontAskAgain": "30日間再確認しない",
    "gameServer": "ゲームサーバー",
    "paymentMethods": "対応支払い方法",
    "paypal": "PayPal",
    "title": "このアカウントで購入してもよろしいですか？",
    "unionPay": "銀聯カード"
  },
  "serverSelect": {
    "characterLabel": "キャラクター名",
    "characterPlaceholder": "キャラクターを選択してください",
    "confirm": "確定",
    "noResults": "結果がありません",
    "serverPlaceholder": "サーバー名を入力して検索してください",
    "title": "ゲームサーバーを選択"
  },
  "orientation": {
    "bestExperience": "最適な体験のため、縦向きでご利用ください"
  },
  "support": {
    "cancel": "キャンセル",
    "copied": "コピー済み",
    "copy": "ワンクリックでコピー",
    "description": "詳細情報を公式サポートメールまでお送りください。",
    "title": "カスタマーサポート"
  },
  "verification": {
    "back": "戻る",
    "enterCode": "続行するには認証コードを入力してください",
    "incorrectCode": "認証コードが正しくありません",
    "invalidCode": "6桁の認証コードを入力してください",
    "noCode": "認証コードが届かない？",
    "sentTo": "認証コードは以下に送信されました",
    "submit": "送信",
    "submitting": "送信中..."
  }
} as const;
